export default __webpack_public_path__ + "static/media/Weather_Dashboard.74627e2d.png";